import { render, staticRenderFns } from "./bookingcounts.vue?vue&type=template&id=0487a25e"
import script from "./bookingcounts.vue?vue&type=script&lang=js"
export * from "./bookingcounts.vue?vue&type=script&lang=js"
import style0 from "./bookingcounts.vue?vue&type=style&index=0&id=0487a25e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports